module.exports = __webpack_public_path__ + "media/country_flags/ss-7c8728f9.png";